<template>
  <div class="mfaq-faqList">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item><a
          href="javascript:void(0)"
          @click="goHome"
          :class="['breadcrump-clickable',isILocalizeFn()?'breadcrump-clickable-KNOWLEDGE':'']"
        >{{displayName}}</a></a-breadcrumb-item>
      <a-breadcrumb-item>{{sectionName}}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="card-wrap">
      <ai-card
        v-for="item in sectionList"
        :key="item.sectionId"
        :item="item"
        :limit="0"
      ></ai-card>
    </div>
  </div>
</template>
<script>
import { loadFaqList } from "@/api/index";
import resultMixin from "./component/resultMixin.js";
import { dealShowPath } from "@/utils/path";
import store from '@/vuex/index'
export default {
  name: "faqList",
  mixins: [resultMixin],
  inject: ["isILocalizeFn"],
  components: {
    aiCard: () => import("./component/aiCard")
  },
  props: {
    loadings: Object
  },
  data() {
    return {
      sectionList: [],
      sectionName: '',
      displayName: "",
    };
  },
  mounted() {
    this.init();
    // this.$bus.pageInfo.isFirst = false
  },
  methods: {
    init() {
      this.$bus.$emit("loading", this.loadings);
      let platform = this.$bus.pageInfo.platform
      let {alias, sectionIdKey, gameIdKey: key} = this.$route.params
      let gameIdKey = this.$bus.pageInfo.gameIdKey || key
      console.log ('params', this.$route.params)
      loadFaqList(alias, gameIdKey, sectionIdKey, platform)
        .then(res => {
          this.displayName = res.displayName;
          this.sectionName = res.sectionList[0].sectionName
          this.initFilter(res, gameIdKey, alias);
          store.commit("CHANGEISSHOWH5", res.isShowH5);
          store.commit("CHANGEAPPID", res.appId);
          store.commit("CHANGEAPPNAME", res.displayName);
          store.commit("CHANGEACCOUNTID", res.accountId);
        })
        .catch(err => {
        });
    },
    goHome() {
      let gameName = this.getGameName();
      let { page, alias, gameIdKey: key} = this.$route.params
      let gameIdKey = this.$bus.pageInfo.gameIdKey || key
      // FAQ/:gameName/:page/:alias/:key
      let path = `/${gameName}/${page}/${alias}/${gameIdKey}`;
      this.$router.push({ path });
    },
    getGameName() {
      let gameName = this.$route.params.gameName;
      return dealShowPath(gameName);
    }
  }
};
</script>
<style lang="scss">
.mfaq-faqList {
  margin-top: 20px;
  .breadcrumb {
    margin-bottom: 20px;
  }
  .breadcrump-clickable {
    color: #409eff;
  }
  .breadcrump-clickable-KNOWLEDGE,.breadcrump-clickable-KNOWLEDGE:hover{
    color: #00bbbb;
  }
  
}
</style>